// de strings for messages/voice.ts. Same keys and {variables} as en there.
// SEO strings follow how German speakers search: "{name} KI-Stimme",
// "{name} KI-Cover".
import type { Dict } from "../index";

const voice: Dict = {
  "voice.seo.title":
    "{name} KI-Stimme: anhören & KI-Cover erstellen | Jammable",
  "voice.seo.description":
    "Hör dir KI-Cover mit {name} an und erstelle deine eigenen in etwa einer Minute. Nutze die von der Community erstellte {name} KI-Stimme für Songs, Text zu Sprache und Duette auf Jammable.",
  "voice.seo.appName": "{name} KI-Stimmengenerator",
  "voice.seo.private": "Private Stimme | Jammable",
  "voice.name": "{name} KI-Stimme",

  "voice.removed": "Diese Stimme wurde entfernt.",
  "voice.private": "Diese Stimme ist privat.",
  "voice.browseOther": "Andere Stimmen ansehen",

  "voice.error": "Etwas ist schiefgelaufen. Bitte versuch es erneut",
  "voice.copied": "In die Zwischenablage kopiert!",

  "voice.newer.body":
    "{username} hat diese Stimme aktualisiert. Probier die neuere Version",
  "voice.newer.cta": "Neuere Version",
  "voice.communityFavourite": "Community-Liebling",
  "voice.uploadedBy": "Hochgeladen von {name}",
  "voice.voices.one": "{n} Stimme",
  "voice.voices.other": "{n} Stimmen",
  "voice.createCover": "Cover erstellen · {uses}× genutzt",
  "voice.like": "Stimme liken",
  "voice.unlike": "Like entfernen",
  "voice.comments": "Kommentare",
  "voice.saveToCollection": "In Sammlung speichern",
  "voice.share": "Stimme teilen",
  "voice.edit": "Stimme bearbeiten",
  "voice.report": "Stimme melden",
  "voice.delete": "Stimme löschen",
  "voice.more": "Mehr",
  "voice.description": "Beschreibung",

  "voice.discord.label": "Sprich mit der Community über {name}",
  "voice.discord.labelNoName": "Sprich mit der Community über KI-Stimmen",
  "voice.discord.body":
    "Teile deine Cover, wünsch dir neue Stimmen und hol dir Tipps auf Discord",

  "voice.similar.title": "Ähnliche KI-Stimmen wie {name}",
  "voice.similar.sub": "Diese Stimmen werden oft zusammen mit {name} genutzt.",
  "voice.similar.moreHub": "Mehr {badge} KI-Stimmen",
  "voice.popularHub.title": "Beliebte {badge} KI-Stimmen",
  "voice.seeAll": "Alle ansehen",
  "voice.collections.title": "Sammlungen mit {name}",
  "voice.collections.titleNoName": "Sammlungen mit dieser Stimme",
  "voice.pairWell.title": "Stimmen, die gut zu {name} passen",

  "voice.about.title": "Über die {name} KI-Stimme",
  "voice.about.use":
    "Nutze die {name} KI-Stimme, um KI-Cover zu erstellen, als Stimmenverzerrer oder für Text zu Sprache.",
  "voice.about.categorised": "Sie gehört zu den Kategorien {list}.",
  "voice.about.uses": "Diese Stimme wurde {n}× auf Jammable genutzt.",
  "voice.howTo.title": "So erstellst du ein {name} KI-Cover",

  "voice.faq.title": "{name} KI-Stimme: Häufige Fragen",
  "voice.faq.sub": "Alles über Cover mit der Stimme von {name}.",
  "voice.link.aiCover": "KI-Cover-Generator",
  "voice.link.voiceChanger": "KI-Stimmenverzerrer",
  "voice.link.browseAll": "Alle KI-Stimmen ansehen",
  "voice.link.weights": "Alternative zu Weights.gg",
  "voice.faq.how.q": "Wie erstelle ich KI-Cover mit {name}?",
  "voice.faq.how.a":
    "Um KI-Cover mit {name} zu erstellen, füge im Studio dein eigenes Audio hinzu (bitte lies unsere {dmca}). Danach klickst du auf Konvertieren! Dein {name} KI-Cover ist in etwa 30–60 Sekunden fertig.",
  "voice.faq.dmca": "DMCA-Richtlinie",
  "voice.faq.input.q":
    "Welches Audio kann ich für meine {name} KI-Cover nutzen?",
  "voice.faq.input.a":
    "Du darfst nur dein eigenes Original-Audio hochladen. Lade keine Aufnahmen hoch, die urheberrechtlich geschütztes Material Dritter enthalten, ohne die Erlaubnis der Rechteinhaber.",
  "voice.faq.time.q": "Wie lange dauert mein {name} KI-Cover?",
  "voice.faq.time.a": "Dein {name} KI-Cover ist in etwa 30–60 Sekunden fertig!",
  "voice.faq.credits.q": "Wie viele Credits kostet ein {name} KI-Cover?",
  "voice.faq.credits.a": "Jedes {name} KI-Cover kostet nur 1 Credit!",
  "voice.faq.acapella.q": "Muss ich eine A-cappella-Version hochladen?",
  "voice.faq.acapella.a":
    "Nein, eine A-cappella-Version brauchst du nicht: Unser System trennt den Gesang für dein {name} KI-Cover sowieso heraus!",
  "voice.faq.changer.q":
    "Kann ich die {name} KI-Stimme als Stimmenverzerrer nutzen?",
  "voice.faq.changer.a":
    "Ja. Du kannst die {name} KI-Stimme als Stimmenverzerrer oder für Text zu Sprache nutzen: Lade dein Audio hoch oder nimm es auf und wandle es in Sekunden in die Stimme von {name} um.",
  "voice.faq.free.q": "Ist die {name} KI-Stimme kostenlos?",
  "voice.faq.free.a":
    "Die Demos der {name} KI-Stimme kannst du kostenlos anhören und ein Cover kostenlos vorbereiten. Zum Erstellen von Covers brauchst du einen Jammable-Plan, mit dem du unbegrenzt {name} KI-Cover, Downloads und mehr bekommst.",

  "voice.demos.title": "Erst mal reinhören",
  "voice.demos.note":
    "Die Demos werden automatisch erstellt, um die Qualität der Stimmen zu zeigen.",
  "voice.demos.maleSinging": "Männlicher Gesang {n}",
  "voice.demos.femaleSinging": "Weiblicher Gesang {n}",
  "voice.demos.english": "Englisch",
  "voice.play": "{name} abspielen",
  "voice.pause": "{name} pausieren",

  "voice.library.title": "Songs mit dieser Stimme",
  "voice.library.sub":
    "Hör dir die KI-Stimme von {name} mit beliebten Songs aus unserer Bibliothek an.",
  "voice.library.unknownSong": "Unbekannter Song",
  "voice.library.unknownArtist": "Unbekannter Künstler",

  "voice.comments.count.one": "{n} Kommentar",
  "voice.comments.count.other": "{n} Kommentare",
  "voice.comments.add": "Kommentar hinzufügen",
  "voice.comments.post": "Posten",
  "voice.comments.top": "Top",
  "voice.comments.newest": "Neueste",
  "voice.comments.empty": "Noch keine Kommentare...",
  "voice.comments.emptySub": "Starte die Unterhaltung!",
  "voice.comments.more": "Mehr Kommentare anzeigen",
  "voice.comments.posted": "Kommentar gepostet!",
  "voice.comments.avatarAlt": "Profilbild",
  "voice.comments.creator": "Ersteller",
  "voice.comments.pinned": "Angeheftet",
  "voice.comments.reply": "Antworten",
  "voice.comments.replyLabel": "Antwort auf Kommentar",
  "voice.comments.replyPlaceholder": "Was meinst du?!",
  "voice.comments.viewReply.one": "{n} Antwort ansehen",
  "voice.comments.viewReply.other": "{n} Antworten ansehen",
  "voice.comments.viewMore": "{n} weitere ansehen",
  "voice.comments.justNow": "gerade eben",
  "voice.comments.minutes": "{n} Min.",
  "voice.comments.hours": "{n} Std.",
  "voice.comments.days": "{n} T.",
  "voice.comments.repliesFailed": "Antworten konnten nicht geladen werden",
  "voice.comments.pinnedToast": "Kommentar angeheftet!",
  "voice.comments.unpinnedToast": "Kommentar nicht mehr angeheftet!",
  "voice.comments.pinFailed": "Kommentar konnte nicht angeheftet werden",
  "voice.comments.pin": "Kommentar anheften",
  "voice.comments.unpin": "Nicht mehr anheften",
  "voice.comments.delete": "Kommentar löschen",
  "voice.comments.report": "Kommentar melden",

  "voice.addTo.title": "Zur Sammlung hinzufügen",
  "voice.addTo.error": "Fehler beim Laden der Sammlungen: {message}",
  "voice.addTo.empty": "Keine Sammlungen gefunden...",
  "voice.addTo.emptySub": "Erstelle deine erste Sammlung!",
  "voice.addTo.new": "Neue Sammlung",
};

export default voice;
